import React from 'react'
import {BsFacebook,BsInstagram,BsTwitter,BsGithub} from "react-icons/bs";
const Footer = () => {
  return (
    <>
   <div className='container-fluid1'>
    <h1> HUM FITNESS</h1>
    <h6>Lorem ipsum sdfdgkasl sogslng sno slengl srlrgn lsnlgnl<br/> nlsdglnl slngnl slnl gl
    </h6>
    <div className='icons'>
        <BsFacebook/>
        <BsInstagram/>
        <BsTwitter/>
        <BsGithub/>
    </div>
    <div className='end'>
        <h6>Copyright ©2022 by HUM FITNESS</h6>
    </div>
   </div>
    </>

  )
}

export default Footer
